// import EarringItem from './earringitem';
import DesignTool from "./designtool";
import { fabric } from "fabric";
import Animation from "./animation";
import { find } from "lodash";

const ZOOM_MAX_SIZE = 1.7;
const ZOOM_MIN_SIZE = 1;
class EarringsView {
  constructor(container, perimeter) {
    this.container = document.createElement("div");
    this.canvas = document.createElement("canvas");

    this.container.width =
      DesignTool.container.size.width ||
      DesignTool.container.target.clientWidth;
    this.container.height =
      DesignTool.container.size.height ||
      DesignTool.container.target.clientHeight;
    this.canvas.width =
      DesignTool.container.size.width ||
      DesignTool.container.target.clientWidth;
    this.canvas.height =
      DesignTool.container.size.height ||
      DesignTool.container.target.clientHeight;

    this.container.appendChild(this.canvas);

    DesignTool.container.target.appendChild(this.container);

    this.earingInfo = {
      color: perimeter.color,
      strokeWidth: 3
    };

    this.lineHeight = perimeter.size;
    DesignTool.unitRatio = Math.min(
      this.canvas.width / this.container.width,
      this.canvas.height / this.container.height
    );

    this.posY = 0;
    this.items = [];
    this.numbers = [];
    this.center = { x: this.canvas.width / 2, y: this.canvas.height / 2 };
    this._callbacks = {};
    let _this = this;

    let ratioImage = (_this.canvas.height * 0.33) / 344; // 344px height image earing
    this.canvasHeight = _this.canvas.height;
    this.canvasWidth = _this.canvas.width;

    fabric.Image.fromURL("../img/earing.png", function(myImg) {
      let offsetTop =
        (_this.canvasHeight - (myImg.height * ratioImage) / 2) / 2;

      var imgEar = myImg
        .set({
          left: _this.center.x,
          top: offsetTop,
          width: myImg.width,
          height: myImg.height,
          hoverCursor: "default",
          draggable: false,
          hasBorders: false,
          hasControls: false,
          lockMovementX: true,
          lockMovementY: true,
          selectable: false,
          evented: false,
          name: "earImg"
        })
        .scale(ratioImage);
      _this.FabricCanvas.add(imgEar);
      _this.FabricCanvas.sendToBack(imgEar);

      if (_this.lineHeight > 0) {
        _this.drawEaring(imgEar);
      } else {
        let earingOne = ((imgEar.height - 100) * imgEar.scaleY) / 2;
        let circleDot = new fabric.Circle({
          radius: _this.earingInfo.strokeWidth,
          left: _this.center.x,
          top: imgEar.top + earingOne,
          fill: _this.earingInfo.color,
          stroke: "",
          strokeWidth: _this.earingInfo.strokeWidth,
          hasBorders: false,
          hasControls: false,
          lockMovementX: true,
          lockMovementY: true,
          selectable: false,
          hoverCursor: "default",
          index: 0,
          name: "circleDot"
        });
        _this.FabricCanvas.add(circleDot);

        DesignTool.unitRatio = 1.5;
        if (window.screen.width > 480) {
          DesignTool.unitRatio = 2;
        }

        if (_this.canvasWidth / _this.canvasHeight >= 2) {
          DesignTool.unitRatio = 1;
        }
      }
    });

    this._initFabric();
    this.animating = false;
    return this;
  }

  drawEaring(imgEar) {
    let earingOne = ((imgEar.height - 100) * imgEar.scaleY) / 2;
    let ratioLine = 1.5;

    if (window.screen.width > 480) {
      ratioLine = 3;
    }

    if (this.canvasWidth / this.canvasHeight >= 2) {
      ratioLine = 1;
    }

    let earing = this.makeFabricLine([
      this.center.x,
      imgEar.top + earingOne,
      this.center.x,
      imgEar.top + earingOne + this.lineHeight * ratioLine
    ]);
    this.FabricCanvas.add(earing);
    DesignTool.unitRatio = ratioLine;
    // this.FabricCanvas.bringToFront(earing);
  }

  makeFabricLine(coords) {
    return new fabric.Line(coords, {
      fill: "",
      stroke: this.earingInfo.color,
      strokeWidth: this.earingInfo.strokeWidth,
      selectable: false,
      evented: false,
      hoverCursor: "default",
      name: "lineImg"
    });
  }

  /**
   * @private
   */
  _initFabric() {
    fabric.Object.prototype.originX = fabric.Object.prototype.originY =
      "center";
    this.FabricCanvas = new fabric.Canvas(this.canvas, {
      hoverCursor: "pointer",
      selection: false,
      perPixelTargetFind: true,
      targetFindTolerance: 5
    });
    var that = this;
    var pointer = null;
    that.deltaAll = { x: 0, y: 0 };

    this.FabricCanvas.on({
      "mouse:move": function(e) {
        if (that.down) {
          let rad = that.pos2Angle(e.pointer, that.center);
          let d = rad - that.da;
          that.lastD = d;

          var item;
          for (var i = 0; i < that.items.length; i++) {
            item = that.items[i];
            item.angle += d;
          }
          that.FabricCanvas.renderAll();
          that.da = rad;
          var date = new Date();
          that.lastScrollTime = date.getTime();
        } else {
          if (that.zoom && pointer != null) {
            that.FabricCanvas.renderAll();
            var delta = new fabric.Point(
              e.pointer.x - pointer.x,
              e.pointer.y - pointer.y
            );
            that.FabricCanvas.relativePan(delta);
            pointer = e.pointer;
          } else {
            if (that.animating) {
              return;
            }
            let obj = that.FabricCanvas.getActiveObject();
            if (obj) {
              let idx = that.items.findIndex(function(o) {
                return obj === o.img;
              });
              if (idx >= 0) {
                let angle = that.pos2Angle(e.pointer, that.center);
                let item = that.items[idx];
                item.angle = angle;
                that.FabricCanvas.renderAll();
              }
            }
          }
        }
      },
      "mouse:up": function(e) {
        if (that.down) {
          var date = new Date();
          var diff = date.getTime() - that.lastScrollTime;
          if (diff < 20) {
            let d = that.lastD;
            var item;
            that.animating = that.items.length > 0 ? true : false;
            for (var i = 0; i < that.items.length; i++) {
              item = that.items[i];
              Animation.animateItem(
                that,
                item,
                item.angle,
                item.angle + 12 * d,
                Math.abs(d) * 7000,
                i === that.items.length - 1,
                function() {
                  that.animating = false;
                }
              );
            }
          }
        } else {
          if (!that.animating) {
            let obj = that.FabricCanvas.getActiveObject();
            let idx = that.items.findIndex(function(o) {
              return obj === o.img;
            });
            if (idx >= 0) {
              let dropItem = that.items[idx];
              that.items.splice(idx, 1);
              if (
                e.pointer.x < 0 ||
                e.pointer.x > that.center.x * 2 ||
                e.pointer.y < 0 ||
                e.pointer.y > that.center.y * 2
              ) {
                // remove object from canvas
                obj.visible = false;
                that.FabricCanvas.remove(obj);
                that.changeRemoveItem(that, e.pointer);
                that._trigger("onchange");
              } else {
                that.insertItem(dropItem, e.pointer, true, true);
              }
              that.FabricCanvas.renderAll();
            }
          }

          if (that.zoom) {
            pointer = null;
          }
        }
        that.FabricCanvas.renderAll();
        that.down = false;
        that.da = Infinity;
        that.FabricCanvas.discardActiveObject(e);
      },
      "mouse:down": function(e) {
        let obj = that.FabricCanvas.getActiveObject();
        if (obj == null) {
          if (that.zoom) {
            pointer = e.pointer;
          } else {
            let x = e.pointer.x - that.center.x;
            let y = e.pointer.y - that.center.y;
            let r = Math.sqrt(x * x + y * y);
            if (r < that.r * 0.8) {
              that.down = true;
              that.da = that.pos2Angle(e.pointer, that.center);
            }
          }
        }
      },
      "mouse:wheel": function(opt) {
        var delta = opt.e.deltaY;
        var zoom = that.FabricCanvas.getZoom();
        if (delta > 0) {
          zoom = zoom + 0.1;
          if (zoom >= ZOOM_MAX_SIZE){
            zoom = ZOOM_MAX_SIZE;
          }
        } else {
          zoom = zoom - 0.1;
          if (zoom <= ZOOM_MIN_SIZE) {
            zoom = ZOOM_MIN_SIZE;
          }
        }
        that._addCheckZoomEarringClass(zoom)
        that.FabricCanvas.zoomToPoint(
          { x: that.center.x, y: that.center.y },
          Math.round(zoom * 100) / 100
        );
        opt.e.preventDefault();
        opt.e.stopPropagation();
      }
    });
  }

  zoomEarring(beforeW, afterW) {
    var zoom = this.FabricCanvas.getZoom();

    if (afterW > beforeW) {
      zoom = zoom + 0.06;
      if (zoom >= ZOOM_MAX_SIZE){
        zoom = ZOOM_MAX_SIZE;
      }
    } else {
      zoom = zoom - 0.06;

      if (zoom <= ZOOM_MIN_SIZE) {
        zoom = ZOOM_MIN_SIZE;
      }
    }
    this._addCheckZoomEarringClass(zoom)
    this.FabricCanvas.zoomToPoint(
      { x: this.center.x, y: this.center.y },
      Math.round(zoom * 100) / 100
    );

    if (zoom > 1) {
      this.zoom = true;
    } else {
      this.zoom = false;
    }

    if (zoom === 1) {
      this.FabricCanvas.absolutePan({ x: 0, y: 0 });
    }
  }

  _addCheckZoomEarringClass(zoom){
    document.getElementById("btn_zoom_in").classList.remove("disabled_button");
    document.getElementById("btn_zoom_out").classList.remove("disabled_button");
    if (zoom == ZOOM_MIN_SIZE) {
      document.getElementById("btn_zoom_out").classList.add("disabled_button");
    }
    if (zoom == ZOOM_MAX_SIZE) {
      document.getElementById("btn_zoom_in").classList.add("disabled_button");
    }
  }

  pos2Angle(p, c) {
    let dx = p.x - c.x;
    let dy = p.y - c.y;
    let dot = dx * (3000 - c.x) + dy * 0;
    let det = dx * 0 + dy * (3000 - c.x);
    let a = Math.atan2(det, dot);
    if (a < 0) {
      a = 2 * Math.PI + a;
    }
    return a;
  }

  addItem(item) {
    let ratioImage = (this.canvasHeight * 0.33) / 344; // 344px height image earing
    let offsetTop = (this.canvasHeight - (344 * ratioImage) / 2) / 2;
    let ratioLine = 1.5;
    let earingOne = ((344 - 100) * ratioImage) / 2;

    if (window.screen.width > 480) {
      ratioLine = 3;
    }

    if (this.canvasWidth / this.canvasHeight >= 2) {
      ratioLine = 1;
    }

    let positionY = offsetTop + earingOne + this.lineHeight * ratioLine;

    if (this.lineHeight === 0) {
      if (this.items.length > 0) {
        this._trigger("onfull");
        return false;
      }
      let that = this;
      let ratioStone = 2;

      DesignTool.unitRatio = 1.5;
      if (window.screen.width > 480) {
        DesignTool.unitRatio = 2;
      }

      if (this.canvasWidth / this.canvasHeight >= 2) {
        ratioStone = 1;
      }

      item.scale = (DesignTool.unitRatio * item.size) / item.imageSize;

      that.items.push(item);
      fabric.Image.fromURL(
        item.imageURL.replace(/^https:\/\//i, "http://"),
        function(img) {
          img.set({
            left: that.center.x,
            top: positionY,
            scaleX: item.scale * ratioStone,
            scaleY: item.scale * ratioStone,
            angle: 90
          });

          img.perPixelTargetFind = true;
          that.FabricCanvas.add(img);
          that.FabricCanvas.bringToFront(img);
          that.FabricCanvas.renderAll();
          item.img = img;
        },
        {
          crossOrigin: "anonymous",
          hasBorders: false,
          hasControls: false
        }
      );
    } else {
      if (this.getMaxEaring() + item.size > this.lineHeight) {
        this._trigger("onfull");
        return false;
      }
      let that = this;
      let i = that.items.length;
      let ratioItem = 11 / 15;

      if (window.screen.width > 480) {
        ratioItem = 1.5;
      }

      if (this.canvasWidth / this.canvasHeight >= 2) {
        ratioItem = 0.5;
      }

      if (i === 0) {
        item.posY = positionY - item.imageSize * item.scale * ratioItem;
      } else {
        item.posY =
          that.items[i - 1].posY -
          (that.items[i - 1].imageSize * that.items[i - 1].scale * ratioItem +
            item.imageSize * item.scale * ratioItem);
      }
      that.items.push(item);

      fabric.Image.fromURL(
        item.imageURL.replace(/^https:\/\//i, "http://"),
        function(img) {
          item.updateSizes(img.width, img.height);
          img.set({
            left: that.center.x,
            top: item.posY,
            scaleX: item.scale,
            scaleY: item.scale,
            angle: 90
          });
          img.perPixelTargetFind = true;
          that.FabricCanvas.add(img);
          that.FabricCanvas.bringToFront(img);
          that.FabricCanvas.renderAll();
          item.img = img;
        },
        {
          crossOrigin: "anonymous",
          hasBorders: false,
          hasControls: false
        }
      );
    }
    this._trigger("onchange");
    return true;
  }

  insertItem(dropItem, pointer, notrigger, inCanvas) {
    let that = this;
    // let ratioImage = (this.canvasHeight * 0.33) / 344; // 344px height image earing
    // let offsetTop = (this.canvasHeight - (344 * ratioImage) / 2) / 2;
    // let earingOne = ((344 - 100) * ratioImage) / 2;
    // let ratioLine = 1.5;

    dropItem.img.angle = 90;

    // if (window.screen.width > 480) {
    //   ratioLine = 3;
    // }

    // if (this.canvasWidth / this.canvasHeight >= 2) {
    //   ratioLine = 1;
    // }

    // let positionY = offsetTop + earingOne + this.lineHeight * ratioLine;

    if (that.lineHeight > 0) {
      if (that.getMaxEaring() + dropItem.size > that.lineHeight) {
        that._trigger("onfull");
        return false;
      }
      if (!dropItem.img) {
        fabric.Image.fromURL(
          dropItem.imageURL.replace(/^https:\/\//i, "http://"),
          function(img) {
            let i = that.items.length;
            dropItem.updateSizes(img.width, img.height);
            if (i === 0) {
              dropItem.posY = that.center.y + that.lineHeight - dropItem.size;
            } else {
              dropItem.posY =
                that.items[i - 1].posY -
                (that.items[i - 1].size + dropItem.size);
            }
            that.items.push(dropItem);
            img.set({
              left: that.center.x,
              top: dropItem.posY,
              scaleX: dropItem.scale,
              scaleY: dropItem.scale
            });
            img.perPixelTargetFind = true;
            that.FabricCanvas.add(img);
            dropItem.img = img;
            that._insertItem(that, dropItem, pointer);
            if (notrigger !== true) {
              that._trigger("onchange");
            }
          },
          {
            crossOrigin: "anonymous",
            hasBorders: false,
            hasControls: false
          }
        );
      } else {
        if (inCanvas) {
          that.changeItem(that, dropItem, pointer);
        } else {
          that._insertItem(that, dropItem, pointer);
        }

        if (notrigger !== true) {
          that._trigger("onchange");
        }
      }
    } else {
      if (that.items.length > 0) {
        that._trigger("onfull");
        return false;
      }
      dropItem.scale =
        (DesignTool.unitRatio * (dropItem.size * DesignTool.unitRatio)) /
        dropItem.imageSize;
      dropItem.img.scaleX = dropItem.scale;
      dropItem.img.scaleY = dropItem.scale;
      that._insertOnlyOneItem(that, dropItem, pointer);
    }
    return true;
  }

  _insertItem(that, dropItem, p) {
    let ratioImage = (this.canvasHeight * 0.33) / 344; // 344px height image earing
    let offsetTop = (this.canvasHeight - (344 * ratioImage) / 2) / 2;
    let earingOne = ((344 - 100) * ratioImage) / 2;
    let ratioLine = 1.5;

    if (window.screen.width > 480) {
      ratioLine = 3;
    }

    if (this.canvasWidth / this.canvasHeight >= 2) {
      ratioLine = 1;
    }

    let positionY = offsetTop + earingOne + this.lineHeight * ratioLine;

    that.FabricCanvas.add(dropItem.img);
    if (that.items.length === 0) {
      let object = find(that.FabricCanvas._objects, function(o) {
        return o.name === "lineImg";
      });

      dropItem.posY = object
        ? object.y2 - (dropItem.imageSize * dropItem.scale) / 2
        : positionY;

      that.items.push(dropItem);
      that.animating = true;
      Animation.animateLine(
        that,
        dropItem,
        p,
        { x: this.center.x, y: dropItem.posY },
        500,
        function() {
          that.animating = false;
        }
      );
    } else {
      if (p) {
        let beforeItem;
        let afterItem;
        for (var j = that.items.length - 1; j >= 0; j--) {
          if (p.y < that.items[j].posY) {
            beforeItem = that.items[j];
            break;
          }
        }

        if (beforeItem) {
          var index = that.items.indexOf(beforeItem);
          if (index >= 0) {
            afterItem = that.items[index + 1];
          }
        }

        if (beforeItem && afterItem) {
          dropItem.posY = p.y;
          let arrTemp = that.items.slice(index);
          arrTemp.splice(1, 0, dropItem);
          if (arrTemp) {
            for (var k = 1; k <= arrTemp.length - 1; k++) {
              let oldPosY = arrTemp[k].posY;

              arrTemp[k].posY =
                arrTemp[k - 1].posY -
                ((arrTemp[k - 1].imageSize * arrTemp[k - 1].scale) / 2 +
                  (arrTemp[k].imageSize * arrTemp[k].scale) / 2);
              that.animating = true;
              Animation.animateItem3(
                that,
                arrTemp[k],
                oldPosY,
                arrTemp[k].posY,
                500,
                k === arrTemp.length - 1,
                function() {
                  that.animating = false;
                }
              );
            }
            if (p) {
              Animation.animateLine(
                that,
                dropItem,
                p,
                { x: that.center.x, y: dropItem.posY },
                500,
                function() {
                  that.animating = false;
                }
              );
            }
          }
          let arrOrigin = that.items.slice(0, index);
          that.items = arrOrigin.concat(arrTemp);
        } else {
          let item = that.items[that.items.length - 1];
          dropItem.posY =
            item.posY -
            ((item.imageSize * item.scale) / 2 +
              (dropItem.imageSize * dropItem.scale) / 2);

          that.animating = true;
          Animation.animateLine(
            that,
            dropItem,
            p,
            { x: that.center.x, y: dropItem.posY },
            500,
            function() {
              that.animating = false;
            }
          );
          that.items.push(dropItem);
        }
      }
    }
  }

  _insertOnlyOneItem(that, dropItem, p) {
    that.FabricCanvas.add(dropItem.img);
    let object = find(that.FabricCanvas._objects, function(o) {
      return o.name === "circleDot";
    });
    dropItem.posY = object
      ? object.top + dropItem.size / 2.5
      : that.center.y + dropItem.size * DesignTool.unitRatio;
    that.items.push(dropItem);
    that.animating = true;
    Animation.animateLine(
      that,
      dropItem,
      p,
      { x: this.center.x, y: dropItem.posY },
      500,
      function() {
        that.animating = false;
      }
    );
    that._trigger("onchange");
  }

  changeItem(that, dropItem, p) {
    let ratioImage = (this.canvasHeight * 0.33) / 344; // 344px height image earing
    let offsetTop = (this.canvasHeight - (344 * ratioImage) / 2) / 2;
    let earingOne = ((344 - 100) * ratioImage) / 2;
    let ratioLine = 1.5;

    if (window.screen.width > 480) {
      ratioLine = 3;
    }

    let positionY = offsetTop + earingOne + this.lineHeight * ratioLine;

    if (p) {
      let beforeItem;
      for (var j = that.items.length - 1; j >= 0; j--) {
        if (p.y < that.items[j].posY) {
          beforeItem = that.items[j];
          break;
        }
      }
      if (beforeItem) {
        var index = that.items.indexOf(beforeItem);
        if (index >= 0) {
          dropItem.posY = p.y;
          that.items.splice(index + 1, 0, dropItem);
        }
      } else {
        that.items.unshift(dropItem);
      }

      if (that.items) {
        for (var k = 0; k <= that.items.length - 1; k++) {
          let oldPosY = that.items[k].posY;
          if (k === 0) {
            let object = find(that.FabricCanvas._objects, function(o) {
              return o.name === "lineImg";
            });

            that.items[k].posY = object
              ? object.y2 - (that.items[k].imageSize * that.items[k].scale) / 2
              : positionY;
          } else {
            that.items[k].posY =
              that.items[k - 1].posY -
              ((that.items[k - 1].imageSize * that.items[k - 1].scale) / 2 +
                (that.items[k].imageSize * that.items[k].scale) / 2);
          }
          that.animating = true;
          Animation.animateItem3(
            that,
            that.items[k],
            oldPosY,
            that.items[k].posY,
            500,
            k === that.items.length - 1,
            function() {
              that.animating = false;
            }
          );
        }
        Animation.animateLine(
          that,
          dropItem,
          p,
          { x: that.center.x, y: dropItem.posY },
          500,
          function() {
            that.animating = false;
          }
        );
      }
    }
  }

  changeRemoveItem(that, p) {
    if (p) {
      if (that.items) {
        for (var k = 0; k <= that.items.length - 1; k++) {
          let oldPosY = that.items[k].posY;
          if (k === 0) {
            let object = find(that.FabricCanvas._objects, function(o) {
              return o.name === "lineImg";
            });

            that.items[k].posY = object
              ? object.y2 - (that.items[k].imageSize * that.items[k].scale) / 2
              : that.center.y + that.lineHeight * 4 - that.items[k].size * 3.5; /// ???????
          } else {
            that.items[k].posY =
              that.items[k - 1].posY -
              ((that.items[k - 1].imageSize * that.items[k - 1].scale) / 2 +
                (that.items[k].imageSize * that.items[k].scale) / 2);
          }
          that.animating = true;
          Animation.animateItem3(
            that,
            that.items[k],
            oldPosY,
            that.items[k].posY,
            500,
            k === that.items.length - 1,
            function() {
              that.animating = false;
            }
          );
        }
      }
    }
  }

  getMaxEaring() {
    return this.items.reduce(function(total, item) {
      return total + item.size;
    }, 0);
  }

  clearItems() {
    for (var i = 0; i < this.items.length; i++) {
      this.FabricCanvas.remove(this.items[i].img);
    }
    this.FabricCanvas.renderAll();
    this.items = [];
  }

  drawNumber() {
    for (var i = 0; i < this.items.length; i++) {
      var textObj = new fabric.Text(i+1+'', { 
        left: this.center.x - (this.items[i].imageSize * this.items[i].scale),
        top: this.items[i].posY,
        fontSize: 20,
        textAlign: "left",
        fill:"#FF0000"  // Set text color to red
      });
      this.numbers.push(textObj);
      this.FabricCanvas.add(textObj);
    }
  }

  clearNumber() {
    for (var i = 0; i < this.numbers.length; i++) {
      this.FabricCanvas.remove(this.numbers[i]);
    }
    this.numbers = [];
  }
  
  toPNGBase64(showNumber = false) {
    let canvasW = this.FabricCanvas.getWidth();
    let canvasH = this.FabricCanvas.getHeight();

    if (canvasW > canvasH) {
      this.FabricCanvas.zoomToPoint({ x: this.center.x, y: this.center.y }, 1);
      if (showNumber) {
        this.drawNumber();
      }
      let data = this.FabricCanvas.toDataURL({
        format: "png",
        left: (canvasW - canvasH) / 2,
        width: canvasH,
        height: canvasH
      });
      if (showNumber) {
        this.clearNumber();
      }
      return data;
    }

    this.FabricCanvas.zoomToPoint({ x: this.center.x, y: this.center.y }, 1.3);
    if (showNumber) {
      this.drawNumber();
    }
    let data = this.FabricCanvas.toDataURL("png");
    if (showNumber) {
      this.clearNumber();
    }
    return data;
  }

  on(event, callback) {
    if (typeof callback === "function") {
      this._callbacks[event] = this._callbacks[event] || [];
      this._callbacks[event].push(callback);
    }
  }

  off(event, callback) {
    if (typeof callback === "function") {
      this._callbacks[event] = this._callbacks[event] || [];
      let idx = this._callbacks[event].indexOf(callback);
      if (idx >= 0) {
        this._callbacks[event].splice(idx, 0);
      }
    }
  }

  _trigger(event, data) {
    if (typeof this._callbacks[event] !== "undefined") {
      this._callbacks[event].forEach(cb => cb(data));
    }
  }
}

export default EarringsView;
